export default __webpack_public_path__ + "static/media/842-cpyrc-ii.38c7c37a.pdf";